// extracted by mini-css-extract-plugin
export default {"productDescription":"Zaa-z","featuredDescription":"_aa-z","description":"aba-z","more":"bba-z","descriptionSku":"cba-z"};